import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const donutChartDescription: CalculatorDescription = {
  id: CalculatorId.DonutChart,
  title: 'Donut Chart Maker',
  metaTitle: 'Free Online Donut Chart Maker - Create Ring Graphs',
  description: 'Create donut charts to display proportional data with a central space for additional information. Perfect for hierarchical data and nested categories.',
  metaDescription: 'Make professional donut charts online. Create ring graphs with our free tool. Visualize proportions and hierarchical data with clear, engaging charts.',
  howTo: {
    title: 'How to Create a Donut Chart',
    steps: [
      'Enter your data in the table or paste from spreadsheet',
      'Select the category column for the segments',
      'Select the value column for the segment sizes',
      'Customize inner radius and center text',
      'Adjust labels and appearance',
      'Download or share your donut chart'
    ],
    graphic: {
      description: 'A step-by-step guide showing how to create a donut chart from data input to final visualization'
    }
  },
  examples: [
    {
      title: 'Revenue Sources',
      description: 'Annual revenue breakdown by source',
      dataDescription: 'Revenue streams with percentage contribution',
      insights: [
        'Online sales contribute 45% of revenue',
        'Retail stores generate 30% of total',
        'B2B partnerships account for 15%',
        'Other channels make up remaining 10%'
      ]
    },
    {
      title: 'Department Staffing',
      description: 'Employee distribution across departments',
      dataDescription: 'Department names with headcount',
      insights: [
        'Engineering team is largest at 40%',
        'Sales and marketing combined at 30%',
        'Operations and support at 20%',
        'Admin and management at 10%'
      ]
    },
    {
      title: 'Project Resource Allocation',
      description: 'Resource allocation across project phases',
      dataDescription: 'Project phases with resource percentages',
      insights: [
        'Development phase uses 50% of resources',
        'Planning and design at 25%',
        'Testing and QA at 15%',
        'Documentation and training at 10%'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.PieChart,
    CalculatorId.NightingaleChart,
    CalculatorId.BarGraph
  ]
}; 